import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat text-12px xxl:text-14px" }
const _hoisted_2 = { class: "justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = {
  key: 1,
  class: "relative w-screen md:w-8/12 lg:w-5/12 h-screen flex flex-col justify-between bg-white"
}
const _hoisted_4 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_5 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4" }, "Detail Aktivitas", -1)
const _hoisted_7 = { class: "px-4 py-4 overflow-auto h-screen" }
const _hoisted_8 = { class: "px-4 pt-2" }
const _hoisted_9 = { class: "flex flex-row my-4" }
const _hoisted_10 = { class: "w-1/2 flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Upload ID ", -1)
const _hoisted_12 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_13 = { class: "w-1/2 flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Status ", -1)
const _hoisted_15 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex flex-col my-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Nama Aktivitas ", -1)
const _hoisted_19 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_20 = { class: "flex flex-col my-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Tipe Berkas ", -1)
const _hoisted_22 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_23 = { class: "text-gray-lp-300 flex" }
const _hoisted_24 = { class: "rounded px-2 py-0 bg-gray-lp-400" }
const _hoisted_25 = { class: "flex flex-col my-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Nama Versi Retail Base Rate ", -1)
const _hoisted_27 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_28 = { class: "flex flex-col my-4" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Client ", -1)
const _hoisted_30 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_31 = { class: "flex flex-col my-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Periode Harga Retail ", -1)
const _hoisted_33 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_34 = {
  key: 0,
  class: "flex flex-col my-4"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Tanggal Aktif Harga ", -1)
const _hoisted_36 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_37 = { class: "border-t border-gray-lp-400 px-4 pt-2" }
const _hoisted_38 = { class: "flex flex-col my-4" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Waktu Dibuat ", -1)
const _hoisted_40 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_41 = { class: "flex flex-col my-4" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Dibuat Oleh ", -1)
const _hoisted_43 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_44 = { class: "flex flex-col my-4" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Attachment Original File ", -1)
const _hoisted_46 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_47 = { class: "flex flex-col my-4" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Attachment Failed File ", -1)
const _hoisted_49 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_detail = _resolveComponent("loading-detail")!
  const _component_initial_name = _resolveComponent("initial-name")!
  const _component_download_attachment = _resolveComponent("download-attachment")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loading_detail, {
            key: 0,
            onClose: _ctx.onClose
          }, null, 8, ["onClose"]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("img", {
                  src: _imports_0,
                  class: "w-4 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                  alt: "x"
                })
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.detailData.id), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("span", {
                          class: 
                        `capitalize text-center rounded-full px-2 ${
                          _ctx.detailData.status?.toLowerCase() === 'success'
                            ? 'bg-green-lp-300 text-green-lp-200'
                            : _ctx.detailData.status?.toLowerCase() ===
                                'partially' ||
                              _ctx.detailData.status?.toLowerCase() === 'waiting'
                            ? 'bg-yellow-lp-200 text-yellow-lp-100'
                            : _ctx.detailData.status?.toLowerCase() === 'uploading'
                            ? 'bg-gray-lp-200 text-black-lp-300'
                            : 'bg-red-300 text-red-lp-100'
                        }`
                      
                        }, _toDisplayString(_ctx.detailData.status) + " " + _toDisplayString(_ctx.isShowCounting(_ctx.detailData.status)
                          ? _ctx.detailData.dataProcessed +
                            "/" +
                            _ctx.detailData.totalData
                          : ""), 3)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailData.activity_name), 1)
                ]),
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.activityTypeName(_ctx.detailData.archive_type)), 1)
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.detailData.name_version), 1)
                ], 512), [
                  [_vShow, _ctx.detailData.name_version]
                ]),
                _withDirectives(_createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.detailData.clientName), 1)
                ], 512), [
                  [_vShow, 
                _ctx.detailData.archive_type
                  ?.toLowerCase()
                  .includes('client-location')
              ]
                ]),
                _withDirectives(_createVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode("div", _hoisted_33, _toDisplayString(_ctx.detailData.periode), 1)
                ], 512), [
                  [_vShow, _ctx.detailData.periode]
                ]),
                (_ctx.detailData.archive_type === 'Update-Retail-Rate')
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode("div", _hoisted_36, _toDisplayString(_ctx.detailData.rate_active_date ? _ctx.formatDateToDateString(_ctx.detailData.rate_active_date) : "-"), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDate(_ctx.detailData.created_at)), 1)
                ]),
                _createVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode("div", _hoisted_43, [
                    _createVNode(_component_initial_name, {
                      name: _ctx.detailData.created_name,
                      email: _ctx.detailData.created_email
                    }, null, 8, ["name", "email"])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("div", _hoisted_46, [
                    _createVNode(_component_download_attachment, {
                      name: _ctx.detailData.archive_file_name,
                      url: _ctx.detailData.archive_file,
                      maxLength: 45
                    }, null, 8, ["name", "url"])
                  ])
                ]),
                _withDirectives(_createVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode("div", _hoisted_49, [
                    _createVNode(_component_download_attachment, {
                      name: _ctx.detailData.failed_file_name,
                      url: _ctx.detailData.failed_file,
                      maxLength: 45,
                      linked: true
                    }, null, 8, ["name", "url"])
                  ])
                ], 512), [
                  [_vShow, _ctx.isShowFailedAttachment(_ctx.detailData.status)]
                ])
              ])
            ])
          ]))
    ]),
    _hoisted_50
  ]))
}